import { Box, styled } from '@mui/material';

export const CarouselWrapper = styled(Box)(() => ({
  position: 'relative',
  margin: '0 auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  maxWidth: { xs: '100%', sm: 1056 },
}));

export const NavButton = styled('button')(({ theme, side }) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: '#494949',
  borderRadius: '50%',
  width: 42,
  height: 42,
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  color: 'white',
  border: 'none',
  cursor: 'pointer',
  display: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 20,
  fontSize: 24,
  lineHeight: 1,
  userSelect: 'none',
  '&:hover': { backgroundColor: 'black' },

  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    left: side === 'left' ? 0 : 'auto',
    right: side === 'right' ? 0 : 'auto',
    transform:
      side === 'left' ? 'translate(35%, -50%)' : 'translate(-35%, -50%)',
  },
}));

export const CarouselImage = styled('img')({
  borderRadius: 5,
  width: '100%',
  height: '100%',
  maxHeight: 300,
  maxWidth: 332,
  objectFit: 'cover',
  cursor: 'pointer',
});

export const SkeletonBox = styled(Box)({
  borderRadius: 5,
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '100%',
  height: 300,
  maxHeight: 300,
  backgroundColor: '#e0e0e0',
  backgroundImage:
    'linear-gradient(90deg, #e0e0e0 0px, #f0f0f0 40px, #e0e0e0 80px)',
  backgroundSize: '200px 100%',
  backgroundRepeat: 'no-repeat',
  animation: 'shimmer 1.5s infinite',
  '@keyframes shimmer': {
    '0%': { backgroundPosition: '-200px 0' },
    '100%': { backgroundPosition: '200px 0' },
  },
  maxWidth: 332,
  minWidth: 332,
});
